import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=2df51367"
import script from "./VMenu.vue?vue&type=script&lang=ts"
export * from "./VMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports